/* CSS */

import "./index.css";

/* Custom scripts */

// import './js/animxyz';
// import './js/aspect-ratios';
// import './js/counterup';
// import './js/inner-height-calc';
// import './js/lightbox';
import "./js/navigation";
import "./js/remove-empty-paragraph";
// import './js/same-height';
import "./js/set-body-height";
import "./js/toggle-outline";
import "./js/marquee-effect";
// import './js/woocommerce';

function highlightActiveLink() {
  // Get the current URL
  const currentUrl = window.location.href;

  // Select all menu links
  const menuLinks = document.querySelectorAll(".matane-primary-menu a"); // Assuming your menu has an ID of 'menu'

  // Iterate over each link in the menu
  menuLinks.forEach((link) => {
    // Check if the link's href matches the current URL
    if (link.href === currentUrl) {
      // Add 'active' class to the matching link
      link.classList.add("active");
    } else {
      // Optional: Remove 'active' class if you have previously added it and the link no longer matches
      link.classList.remove("active");
    }
  });
}

// Call the function when the page loads
document.addEventListener("DOMContentLoaded", highlightActiveLink);

// eslint-disable-next-line import/no-extraneous-dependencies
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";

// gsap.registerPlugin(ScrollTrigger, Observer);

// const revealContainers = document.querySelectorAll(".reveal-container");

// revealContainers.forEach((container) => {
// 	const image = container.querySelector("img");
// 	const tl = gsap.timeline({
// 		scrollTrigger: {
// 			trigger: container,
// 			toggleActions: "restart none none reset",
// 		},
// 	});

// 	tl.set(container, { autoAlpha: 1 });
// 	tl.from(container, 1.5, {
// 		xPercent: -100,
// 		ease: Power2.out,
// 	});
// 	tl.from(image, 1.5, {
// 		xPercent: 100,
// 		scale: 1.3,
// 		delay: -1.5,
// 		ease: Power2.out,
// 	});
// });

/* Swiper */

// import Swiper from "swiper";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// import "swiper/swiper-bundle.css";

// import './js/swiper/swiper-overflow-slider';
// import './js/swiper/swiper-testimonials-slider';
// import './js/swiper/swiper-fullscreen-slider';

/* Spotlight */

// import spotlight, { prev } from 'spotlight.js';

/* chartjs */

// import Chart from 'chart.js/auto';

// Select all the "Read more" links in an array
const readMoreLinks = document.querySelectorAll(".medarbetare-read-more-link");

// Loop through each link and attach the click event
readMoreLinks.forEach((link) => {
  link.addEventListener("click", function (event) {
    // Prevent the default behavior of the link
    event.preventDefault();

    // Get the parent .medarbetare-card of the clicked link
    const card = this.closest(".medarbetare-card");

    // If this card is already active, remove the active class and return
    if (card.classList.contains("medarbetare-card-active")) {
      card.classList.remove("medarbetare-card-active");
      return;
    }

    // If another card is active, remove 'medarbetare-card-active' class from it
    document
      .querySelectorAll(".medarbetare-card.medarbetare-card-active")
      .forEach((activeCard) => {
        activeCard.classList.remove("medarbetare-card-active");
      });

    // Add 'medarbetare-card-active' class to the parent .medarbetare-card of the clicked link
    card.classList.add("medarbetare-card-active");
  });
});

// Handle the close button functionality
const closeButtons = document.querySelectorAll(
  ".medarbetare-card-close-button"
);

closeButtons.forEach((button) => {
  button.addEventListener("click", function () {
    // Get the parent .medarbetare-card of the clicked close button
    const card = this.closest(".medarbetare-card");

    // Remove 'medarbetare-card-active' class from it
    card.classList.remove("medarbetare-card-active");
  });
});

// Handle closing by clicking on the background
const backgrounds = document.querySelectorAll(
  ".medarbetare-read-more-card-background"
);

backgrounds.forEach((background) => {
  background.addEventListener("click", function (event) {
    // Ensure only the background itself was clicked, not its child elements
    if (event.target === event.currentTarget) {
      // Get the parent .medarbetare-card of the clicked background
      const card = this.closest(".medarbetare-card");

      // Remove 'medarbetare-card-active' class from it
      card.classList.remove("medarbetare-card-active");
    }
  });
});

/*

Togglar filter i shop page i mobilen

*/

document.addEventListener("click", function (e) {
  if (e.target.closest(".mobile-filter-button")) {
    const filterContainer = document.querySelector(
      ".matane-wc-side-menu-container"
    );
    if (filterContainer) {
      filterContainer.classList.toggle("matane-wc-side-menu-container-active");
    }
  }
});

/*

Smooth scroll to anchor links

*/

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const targetId = this.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
      });
    }
  });
});

/*

Togglar läs mer text på partner sidan och WooCommerce arkivsidor.

*/

// Handle the original toggle button (for partner page)
const originalToggleButton = document.getElementById("toggle-button");
if (originalToggleButton) {
  originalToggleButton.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default anchor behavior
    const textContent = document.querySelector(".matane-show-more-text");
    textContent.classList.toggle("expanded");

    // Change button text based on visibility
    this.textContent = textContent.classList.contains("expanded")
      ? "Visa mindre -"
      : "Visa mer +";
  });
}

// Handle WooCommerce archive description toggle buttons
document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".matane-toggle-button");

  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default anchor behavior

      // Get the corresponding text content using the button's ID
      const buttonId = this.id;
      const textContent = document.getElementById("desc-" + buttonId);

      if (textContent) {
        textContent.classList.toggle("expanded");

        // Change button text based on visibility
        this.textContent = textContent.classList.contains("expanded")
          ? "Visa mindre -"
          : "Visa mer +";
      }
    });
  });
});
